import {
    Button,
    Divider,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import getShopUrl from "../../getShopUrl";
import redirectToSignInPage from "../redirectToSignInPage";
import useAuthentication from "../state/useAuthentication";
import AccountMenu from "./AccountMenu";
import AllQuotaDisplay from "./AllQuotaDisplay";
import Branding from "./Branding";
import PayPerUseSwitch from "./PayPerUseSwitch";

export default function MainHeader() {
    const { authenticationState } = useAuthentication();

    const compactMode = useMediaQuery(useTheme().breakpoints.down("md"));

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                height: "68px",
                backgroundColor: "#000",
                padding: "3px 12px 3px 20px",
            }}
        >
            <Branding />
            {authenticationState.type === "REGISTERED_USER_AUTHENTICATED" ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                    {!compactMode && <GetDesktopAppButton />}
                    <AllQuotaDisplay />
                    <PayPerUseSwitch compactMode={compactMode} />
                    <Divider
                        orientation="vertical"
                        variant="fullWidth"
                        style={{
                            marginLeft: "8px",
                            marginRight: "8px",
                        }}
                    />
                    <AccountMenu user={authenticationState.authenticatedUser} />
                </div>
            ) : (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "24px",
                    }}
                >
                    {!compactMode && (
                        <>
                            <GetDesktopAppButton />
                            <Divider orientation="vertical" />
                            <Typography
                                sx={{ display: { xs: "none", lg: "block" } }}
                            >
                                Already have an account?
                            </Typography>
                        </>
                    )}
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => redirectToSignInPage()}
                        disabled={
                            authenticationState.type ===
                                "REGISTERED_USER_AUTHENTICATING" ||
                            authenticationState.type ===
                                "GUEST_USER_AUTHENTICATING"
                        }
                        sx={{
                            padding: {
                                xs: "10px 10px",
                                lg: "10px 24px",
                            },
                        }}
                    >
                        Sign In
                    </Button>
                </div>
            )}
        </div>
    );
}

function GetDesktopAppButton() {
    return (
        <Button
            variant="outlined"
            color="secondary"
            href={`${getShopUrl()}/installers#production-tools`}
            sx={{
                padding: {
                    xs: "10px 10px",
                    lg: "10px 24px",
                },
            }}
        >
            Get desktop app
        </Button>
    );
}
